var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "q-menu",
    {
      style: "float: " + _vm.float,
      attrs: {
        mode: _vm.mode,
        "default-active": _vm.defaultMenuActive,
        router: _vm.router,
        collapse: _vm.isCollapse,
        "background-color": _vm.backgroundColor,
        "text-color": _vm.foreColor,
        "active-text-color": _vm.activeTextColor,
      },
      on: { select: _vm.handleSelect },
    },
    _vm._l(_vm.menus, function (menu) {
      return _c("q-menu-bar-item", {
        key: menu.index,
        attrs: { mode: _vm.mode, menu: menu },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }